import styles from "./styles.module.scss";
import Whatsapp from "../../public/static-next/icons/whatsapp.svg";
import Facebook from "../../public/static-next/icons/facebook.svg";
import Twitter from "../../public/static-next/icons/twitter.svg";
import Linkedin from "../../public/static-next/icons/linkedin.svg";
import Link from "next/link";

interface TypeLink {
  shareLink: string;
}

export const SocialShare = ({ shareLink }: TypeLink) => {
  return (
    <div className={styles.share}>
      <span>Compartilhe esse post:</span>
      <Link
        target="_blank"
        rel="noreferrer"
        href={`https://api.whatsapp.com/send?text=${shareLink}`}
      >
        <Whatsapp />
      </Link>
      <Link
        target="_blank"
        rel="noreferrer"
        href={`https://www.facebook.com/sharer/sharer.php?u=${shareLink}`}
      >
        <Facebook />
      </Link>
      <Link
        target="_blank"
        rel="noreferrer"
        href={`https://linkedin.com/share?url=${shareLink}`}
      >
        <Linkedin />
      </Link>
      <Link
        target="_blank"
        rel="noreferrer"
        href={`https://twitter.com/share?url=${shareLink}`}
      >
        <Twitter />
      </Link>
    </div>
  );
};
